module.exports = __webpack_public_path__ + "static/media/riviero_pusins.9e676c6d.jpg";